<template>
  <div>
    <my-notification :icon="'table'">
      <template #title>
        {{ $t('compScenarioDocsScenarioData.title') }}
      </template>
      <p>
        {{ $t('compScenarioDocsScenarioData.data-1') }}
        <br /><br />
      </p>
      <div>
        <ul style="list-style-type: square; margin-left: 25px">
          <li><span v-html="$t('compScenarioDocsScenarioData.data-2')" /></li>
          <li><span v-html="$t('compScenarioDocsScenarioData.data-3')" /></li>
        </ul>
      </div>
    </my-notification>
  </div>
</template>

<script>
export default {
  name: 'ScenarioData',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  }
}
</script>
